"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const FileIcon_vue_1 = __importDefault(require("./FileIcon.vue"));
const LinkUI_vue_1 = __importDefault(require("./LinkUI.vue"));
const Loader_vue_1 = __importDefault(require("../Toolkit/Common/UI/Loader.vue"));
const ModalStamp_vue_1 = __importDefault(require("../Common/ModalStamp.vue"));
const axios_1 = __importDefault(require("axios"));
const { ChevronLeft, Upload, ArrowLeftRight } = require('lucide-vue-next');
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let DragDrop = class DragDrop extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.selectPRJ = false;
        this.extensionFiles = ['shp', 'dbf', 'shx', 'prj'];
        this.extensionOptionalFiles = ['prj'];
        this.somethingDragging = false;
        this.File = [];
        this.droppedFiles = [];
        this.allowSend = true;
        this.loader = false;
        this.extensionErrorFiles = [''];
        this.EPSG = 'EPSG:4326';
        this.source = 'tracking';
        // MAP PAYLOAD
        this.polygons = [];
        this.fileNameMap = '';
    }
    enablePRJ() {
        if (this.selectPRJ) {
            this.extensionFiles.pop();
        }
        else {
            this.extensionFiles.push('.prj');
        }
    }
    async sendFiles() {
        const formData = new FormData();
        for (const file of this.droppedFiles) {
            formData.append('file-' + file.name.slice(file.name.lastIndexOf('.') + 1, file.name.length), file);
        }
        formData.append('type', 'shp');
        formData.append('prj_code', this.EPSG);
        formData.append('source', this.source);
        try {
            const data = await axios_1.default.post('/tracking/preload', formData);
            const res = data;
            this.polygons = res.data.polygons;
            this.fileNameMap = res.data.file_name;
            this.openModal('success', [], res.data.msg, res.data.polygons, res.data.file_name);
        }
        catch (error) {
            this.openModal('error', [], error, [], '');
        }
    }
    openModal(typeModal, extensionErrorFiles, error, poligonos, name) {
        this.$emit('openModal', true, typeModal, error, poligonos, name);
        this.extensionErrorFiles = extensionErrorFiles;
    }
    activeSendFile() {
        // Check if all files dropped
        if (this.droppedFiles.length === this.extensionFiles.length) {
            this.allowSend = true;
        }
        else {
            this.allowSend = false;
        }
        // Check if only missing is among the optionals
        if (this.droppedFiles.length !== this.extensionFiles.length - this.extensionOptionalFiles.length) {
            this.allowSend = false;
        }
        else {
            if (this.missingFilesByExtension().length > 0) {
                this.allowSend = true;
            }
            else {
                this.allowSend = false;
            }
        }
    }
    missingFilesByExtension() {
        const obligExtensions = this.extensionFiles.filter((allowedExtension) => !this.extensionOptionalFiles.includes(allowedExtension)).map((obligExt) => obligExt);
        const obligExtensionsMissings = obligExtensions.filter((obExt) => {
            if (this.droppedFiles.find((dropFile) => dropFile.name.endsWith(obExt)))
                return true;
            return false;
        });
        return obligExtensionsMissings;
    }
    setToast(type) {
        this.$emit('toast', this.droppedFiles.length);
        this.$emit('type', type);
    }
    toggleActive() {
        return (this.somethingDragging = !this.somethingDragging);
    }
    async dropHandler(e) {
        this.loader = true;
        await setTimeout(() => {
            this.loader = false;
        }, 1000);
        const droppedFiles = [...e.dataTransfer.files];
        if (droppedFiles.length > 0) {
            // Use DataTransferItemList interface to access the file(s)
            droppedFiles.forEach(file => {
                this.fileHandler(file);
            });
        }
        this.toggleActive();
    }
    fileHandler(file) {
        const ix = file.name.lastIndexOf('.') + 1;
        const fileExtension = file.name.slice(ix, file.name.length);
        // Check if dropped file extension is one of the expected extensions
        // If not, the file won't be added to the array
        if (this.extensionFiles.includes(fileExtension)) {
            // Add to array, if exist with the same format, replace it
            const foundFileWithExtensionIx = this.droppedFiles.findIndex((currFile) => currFile.name.endsWith(fileExtension));
            this.setToast('success');
            if (foundFileWithExtensionIx === -1) {
                this.droppedFiles.push(file);
            }
            else {
                this.droppedFiles[foundFileWithExtensionIx] = file;
            }
            this.activeSendFile();
        }
        else {
            this.setToast('error');
        }
    }
    findDroppedByExtension(e) {
        const alreadyDroppedIx = this.droppedFiles.findIndex((currFile) => currFile.name.endsWith(e));
        return alreadyDroppedIx;
    }
    resetFile(e) {
        this.droppedFiles.splice(this.findDroppedByExtension(e), 1);
        this.activeSendFile();
    }
    setView(value) {
        this.$emit('setView', value);
    }
};
__decorate([
    (0, vue_property_decorator_1.Watch)('selectPRJ')
], DragDrop.prototype, "enablePRJ", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('droppedFiles')
], DragDrop.prototype, "activeSendFile", null);
DragDrop = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            UploadCloud: lucide_vue_next_1.UploadCloud,
            FileIcon: FileIcon_vue_1.default,
            LinkUI: LinkUI_vue_1.default,
            ChevronLeft,
            Upload,
            Loader: Loader_vue_1.default,
            ModalStamp: ModalStamp_vue_1.default,
            ArrowLeftRight,
            Trash2: lucide_vue_next_1.Trash2
        },
    })
], DragDrop);
exports.default = DragDrop;
